import { useFormContext } from 'react-hook-form';

import type { FormTextEditorProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { TextEditor } from '@/components/TextEditor';
import { Field, FieldDescription, FieldError } from '@/components/ui/field';
import { FormField } from '@/components/ui/form';

export const FormTextEditor = <TFieldValues extends FieldValues = FieldValues>(
  props: FormTextEditorProps<TFieldValues>,
) => {
  const { name, label, description, isRequired, disabled, control } = props;
  const formContext = useFormContext<TFieldValues>();
  const formControl = control || formContext.control;

  const fieldId = `form-field-${String(name)}`;

  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field, fieldState }) => {
        const fieldLabel = (
          <>
            {label}
            {isRequired && (
              <span
                className={
                  fieldState.invalid
                    ? 'text-destructive'
                    : 'text-muted-foreground'
                }
              >
                *
              </span>
            )}
          </>
        );

        return (
          <Field data-invalid={fieldState.invalid}>
            <TextEditor
              id={fieldId}
              value={field.value || ''}
              label={fieldLabel}
              disabled={disabled}
              aria-invalid={fieldState.invalid}
              onChange={field.onChange}
              onBlur={field.onChange}
            />
            {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            {description && <FieldDescription>{description}</FieldDescription>}
          </Field>
        );
      }}
    />
  );
};
